import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { InitWorkReportRequest } from '../models/form/init-work-report-request.model';
import { MaterialInspection } from '../models/inspection/material-inspection.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class InspectionMaterialService extends RequestService<MaterialInspection> {
  static PATH = '/inspection/material';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, InspectionMaterialService.PATH, globalService.debugUrl);
  }

  generateReport(idList: number[], formCode: string) {
    return this.httpClient.post<InitWorkReportRequest>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${InspectionMaterialService.PATH}/generateInitWorkReportRequestV2`,
      {
        idList,
        formCode,
      }
    );
  }

  updateExt(req: MaterialInspection) {
    return this.httpClient.post<boolean>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${InspectionMaterialService.PATH}/updateExt`,
      req
    );
  }
}
